export const errorMessage = 'Something went wrong. Please try again.';
export const noDataMessage = 'No data. Something went wrong. Please try again.';

export const archiveAudienceError = 'Unable to archive audience. Please try again later.';
export const archiveAudienceSuccess = 'Audience has been successfully archived.';
